export var name = 'options';
export var DEFAULT_SELECTED_SPORT_ID = 1;
export var DEFAULT_SELECTED_SPORT_NAME = 'soccer';
